import PropTypes from "prop-types"
import { useSelector } from "react-redux"

import AccordionThumbnail from "areas/product/jewlr/wizard-options/accordion-thumbnail"
import { to_currency } from "helpers/number"

import AccentOption from "./accent-option"
import StoneOption from "./stone-option"

const GuidedStonePickerStep = ({
  handleCategoryClick,
  pref,
  selectedCategory,
}) => {
  const wizardData = useSelector((state) => state.wizard.data[pref])
  const selectedStone = useSelector((state) => state.choices[pref])

  if (!wizardData || !selectedStone) {
    return null
  }

  return (
    <>
      <div aria-atomic aria-live="polite" className="mb-12">
        <h3 className="text-14 font-medium">
          <span className="font-semibold">{wizardData.heading?.title}</span>:{" "}
          {selectedStone.info || selectedStone.title}
          {selectedStone.birthmonth ? (
            <>&ndash; {selectedStone.birthmonth} Birthstone</>
          ) : (
            ""
          )}
        </h3>
        <p className="text-12 text-grey-500 mt-4 font-semibold">
          {selectedCategory && <>{selectedCategory?.type} &ndash; </>}
          {wizardData.stone_size && (
            <span dangerouslySetInnerHTML={{ __html: wizardData.stone_size }} />
          )}
        </p>
      </div>
      <div className="tablet:mt-0 tablet:px-0 my-10 hidden gap-10 px-16">
        <AccordionThumbnail className="m-0 size-48" pref={pref} />
        <div className="leading-18 flex-1">
          <div className="text-14 leading-20 flex items-center justify-between gap-10 font-semibold">
            <h2>{wizardData?.heading?.title}</h2>
            <span>{to_currency(selectedStone?.price)}</span>
          </div>
          {selectedStone && (
            <p className="text-12 text-grey-500 font-semibold">
              {selectedStone.stoneName || selectedStone.title}
              {selectedStone.birthmonth ? ` / ${selectedStone.birthmonth}` : ""}
            </p>
          )}
          {wizardData?.stone_size && (
            <p className="text-12 text-grey-500 font-semibold">
              Stone Size:{" "}
              <span
                dangerouslySetInnerHTML={{ __html: wizardData.stone_size }}
              />
            </p>
          )}
        </div>
      </div>
      {pref === "as" ? (
        <AccentOption pref={pref} />
      ) : (
        <StoneOption
          handleCategoryClick={handleCategoryClick}
          pref={pref}
          selectedCategory={selectedCategory}
        />
      )}
    </>
  )
}

GuidedStonePickerStep.propTypes = {
  handleCategoryClick: PropTypes.func,
  pref: PropTypes.string,
  selectedCategory: PropTypes.object,
}

export default GuidedStonePickerStep
